import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined'
import { Box } from '@mui/material'

const TRUSTED_SOURCE_BACKGROUND = '#083464'
const TRUSTED_SOURCE_COLOUR = '#ffffff'

const TrustedSourcesRequiredLabel = () => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      bgcolor: TRUSTED_SOURCE_BACKGROUND,
      color: TRUSTED_SOURCE_COLOUR,
      px: '10px',
      py: '5px',
      borderRadius: '5px',
    }}
  >
    <AccountBalanceOutlinedIcon
      data-testid="trusted-sources-required-icon"
      sx={{ fontSize: 20, color: 'inherit' }}
    />
    <span>Trusted Sources Required</span>
  </Box>
)

export default TrustedSourcesRequiredLabel
